import styled from 'styled-components';

export const SubMenuContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 5px;
  height: 40px;
`;

export const LinkItem = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    color: #666666;
    font-weight: 400;
    padding: 10px;
    margin-right: 10px;
    font-size: 15px;
    cursor: pointer;
    transition: all 0.3s ease;
    border-bottom: 2px solid transparent;

    span {
        background-color: #2e2e2e;
        color: #ffffff;
        font-size: 11px;
        padding: 3px 5px;
        border-radius: 5px;
        margin-left: 5px;
    }

    &.active {
        color: #000000d6;
        border-bottom: 2px solid #000000d6;
        font-weight: 500;
    }

    :hover {
        background-color: #6666661a;
        color: #000000d6;
        border-radius: 5px;      
        border-bottom: 2px solid transparent;  
    }
`;

export const IconBlock = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    justify-content: center;
    background-color: #2e2e2e;
    color: #ffffff;
    font-size: 11px;
    padding: 3px 5px;
    border-radius: 5px;    
    margin-right: 5px;    
    padding: 5px;
`;

export const SubMenuContainerBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 5px;
  height: 75px;
`;

export const LinkItemBlock = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: #666666;
    font-weight: 400;
    padding: 10px;
    margin-right: 10px;
    font-size: 15px;
    cursor: pointer;
    transition: all 0.3s ease;
    border-bottom: 2px solid transparent;
    gap: 5px;
    max-width: 120px;
    min-width: 120px;
    height: 75px;
    text-align: center;
    position: relative;
    border: 2px solid transparent;
    border-radius: 8px;

    /* Efeito de borda animada */
    &::before {
        content: '';
        position: absolute;
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;
        background: linear-gradient(45deg, #007bff, #0056b3, #007bff);
        background-size: 300% 300%;
        border-radius: 10px;
        z-index: -1;
        opacity: 0;
        transition: opacity 0.3s ease;
        animation: borderRotate 2s linear infinite;
    }

    @keyframes borderRotate {
        0% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
        100% { background-position: 0% 50%; }
    }

    /* Animação do ícone */
    .icon {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }

    span {
        background-color: #2e2e2e;
        color: #ffffff;
        font-size: 11px;
        padding: 3px 5px;
        border-radius: 5px;
        margin-left: 5px;
    }

    &.active {
        color: #000000d6;
        border-bottom: 2px solid #000000d6;
        font-weight: 500;
        border-radius: 0px;
        
        .icon {
            transform: translateY(-2px) scale(1.05);
        }

        &::before {
            opacity: 1;
        }
    }

    :hover {
        background-color: #6666661a;
        color: #000000d6;
        border-radius: 8px;      
        border-bottom: 2px solid transparent;
        
        .icon {
            transform: translateY(-3px) scale(1.1);
        }

        &::before {
            opacity: 1;
        }
    }
`;

export const IconBlockMax = styled.div<{ backgroundColor?: string }>`
    display: flex;
    justify-content: center;
    align-items: center;
    justify-content: center;
    background-color: #2e2e2e;
    color: #ffffff;    
    padding: 3px 5px;
    border-radius: 5px;    
    margin-right: 5px;        
    padding: 7px;
    font-size: 15px;

    background: ${(props) => props.backgroundColor || '#2e2e2e'};
`;